import { createSlice } from "@reduxjs/toolkit";
export const cartSlice = createSlice({
  name: "Cart",
  initialState: {
    data: {},
    status: false,
    isEdit: false,
    tickets: [],
  },
  reducers: {
    updCartData: (state, action) => {
      state.data = action.payload.data;
      state.status = action.payload.status;
    },
    markCartEdit: (state, action) => {
      state.isEdit = action.payload;
    },
  },
});
export const { updCartData, markCartEdit } = cartSlice.actions;
export default cartSlice.reducer;
